import type { ReactNode } from 'react'
import styles from './OpportunityDetailsActions.module.css'

export interface OpportunityDetailsActionsProps {
  children: ReactNode
}

export function OpportunityDetailsActions({
  children,
}: OpportunityDetailsActionsProps) {
  return <div className={styles.actions}>{children}</div>
}
